import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { Card } from 'components/card';
import { useStaticQuery, graphql } from 'gatsby';
import media from 'constants/styles/media';
import { Header } from 'components/header';
import { SECTION_IDS } from 'constants/index';
import { BodyText } from 'components/typography/bodyText';
import { Section } from 'components/layout/Section';

const SSection = styled(Section)`
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const SCardWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 36px;
    place-items: center;

    @media (max-width: ${media.tablet}) {
        grid-template-columns: 1fr;
        grid-gap: 24px;
    }
`;

const SWrapper = styled.div`
    text-align: left;
    align-self: flex-start;
    margin-bottom: 36px;
    max-width: 632px;
`;

export const WhatDoYouGetSection = () => {
    const { t } = useTranslation();
    const { icons } = useStaticQuery(graphql`
        query whatDoYouGet {
            icons: allFile(
                filter: { relativeDirectory: { eq: "what-do-you-get" } }
                sort: { fields: relativePath, order: ASC }
            ) {
                nodes {
                    id
                    publicURL
                }
            }
        }
    `);

    return (
        <SSection id={SECTION_IDS.SYSTEM}>
            <SWrapper>
                <Header text={t('what-do-you-get.header')} />
                <BodyText>{t('what-do-you-get.description')}</BodyText>
            </SWrapper>
            <SCardWrapper>
                {icons.nodes.map((icon: { id: string; publicURL?: string }, i: number) => {
                    if (!icon.publicURL) return null;
                    return (
                        <Card
                            header={t(`what-do-you-get.card${i + 1}.header`)}
                            description={t(`what-do-you-get.card${i + 1}.description`)}
                            iconSrc={icon.publicURL}
                            key={icon.id}
                        />
                    );
                })}
            </SCardWrapper>
        </SSection>
    );
};
